import { Card } from "@wojo/ui";
import cn from "clsx";
import styles from "./InfoTable.module.scss";

export type InfoTableProps = React.PropsWithChildren<{
    "aria-label"?: string;
    "aria-labelledby"?: string;
    className?: string;
}>;

export const InfoTable: React.FC<InfoTableProps> = ({
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledBy,
    className,
    children,
}) => {
    const hasLabel = !!ariaLabel || !!ariaLabelledBy;
    return (
        <Card
            role={hasLabel ? "group" : undefined}
            aria-label={ariaLabel}
            aria-labelledby={ariaLabelledBy}
            className={cn(styles["info-table"], className)}
        >
            {children}
        </Card>
    );
};
